export class DistanceDisplay {
  constructor(offer, locationData) {
    this.offer = offer;
    this.locationData = locationData;
  }

  get value() {
    // If doing location-based search, use Elasticsearch script results
    if (this.locationData?.lat && this.locationData?.lng) {
      if (this.offer.min_distance != null && this.offer.min_distance !== undefined) {
        // Elasticsearch script fields return arrays, extract the first element
        return Array.isArray(this.offer.min_distance) 
          ? this.offer.min_distance[0] 
          : this.offer.min_distance;
      }
      return null;
    }
  }

  get text() {
    if (this.value == null || this.value === undefined) {
      return null;
    }
    
    // If it's already a string, return as-is
    if (typeof this.value === 'string') {
      return this.value;
    }
    
    // If it's a number, add suffix
    return `In-store · ${this.value} km away`;
  }

  get shouldShow() {
    // Only show distance when doing location-based search
    if (!this.locationData?.lat || !this.locationData?.lng) {
      return false;
    }
    
    // Only show numeric distances (Elasticsearch already filtered by radius)
    return typeof this.value === 'number';
  }
}